import { useEffect } from 'react'

import { TGetItemFn, TSetItemFn } from '@/config/types'
import { CheckoutFlowVersion } from '@/enums/payments'

import { IUser } from '@/auth/types'
import { leadEventSentAt } from '@/core/constants'
import { ISessionContext } from '@/core/session'

import { trackLead } from './events'

export function isLeadEventSent(getItem: TGetItemFn): boolean {
  return Boolean(getItem(leadEventSentAt))
}

export function markLeadEventSent(setItem: TSetItemFn) {
  setItem(leadEventSentAt, new Date().toString())
}

export function useLeadEvent(
  getItem: TGetItemFn,
  setItem: TSetItemFn,
  sessionContext: ISessionContext,
  pixelId: string,
  twPixelId: string | undefined,
  tiktokPixelId: string | undefined,
  user: IUser | null
) {
  useEffect(() => {
    if (sessionContext.checkoutFlowVersion == CheckoutFlowVersion.V1) {
      return
    }
    if (sessionContext.isAnalyticsEnabled && !isLeadEventSent(getItem)) {
      trackLead(sessionContext, pixelId, twPixelId, tiktokPixelId, user)
      markLeadEventSent(setItem)
    }
  }, [pixelId, twPixelId, tiktokPixelId, sessionContext, user, getItem, setItem])
}
